import React from 'react';
import { useNotification } from '../../context/NotificationContext';
import './Notification.css'; // We'll create this next

function Notification() {
  const { message, notificationType } = useNotification();

  // If there's no message, render nothing
  if (!message) {
    return null;
  }

  // Otherwise, render the notification box
  // It uses the 'type' to change its color (e.g., success or error)
  return (
    <div className={`notification ${notificationType}`}>
      {message}
    </div>
  );
}

export default Notification;
